import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Input, Utils, Toastr } from "arv-reactcomponents";
import { validateEmail } from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import GTM from "../../../analytics/GTM";

@inject("FooterStore")
@observer
class EmailSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subsriberEmail: "",
    };

    this.subsribeSubmit = this.subsribeSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  subsribeSubmit() {
    if (validateEmail(this.state.subsriberEmail)) {
      this.props.FooterStore.subscribe(this.state.subsriberEmail);
      Analytics.trackEvent({
        action: Event.action.SUBSCRIBE_USER,
        category: Event.category.FOOTER,
        label: Event.label.getEmailSubscribeLabel(this.state.subsriberEmail),
      });
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: "Good Mooove! You've Just Signed Up For The Latest Updates",
        timeout: 3000,
      });

      GTM.pushWithEvent(
        {
          emailId: this.state.subsriberEmail
        }, Event.GTMEvent.EMAIL_SUBSCRIBE
      );

    } else {
      console.log("Invalid email");
    }
  }

  handleChange(event) {
    this.setState({ subsriberEmail: event.target.value });
  }
  render() {
    return (
      <div className="nw-newsletter-container">
        <h3 className="nw-newsletter-heading">
          Get The Latest News & Offers In Beauty & Fashion
        </h3>
        <div className="nw-subscription-container">
          <Input
            onChange={this.handleChange}
            className="nw-subscription-input nwc-inp-normal"
            type="email"
            placeholder="Enter your email address"
            value={this.state.subsriberEmail}
          />
          <Button
            className="nw-subscription-submit nwc-btn-normal"
            onClick={this.subsribeSubmit}
            onKeyPress={Utils.noop}
          >
            SUBSCRIBE
          </Button>
        </div>
      </div>
    );
  }
}

EmailSubscription.wrappedComponent.propTypes = {
  FooterStore: PropTypes.shape({
    subscribe: PropTypes.func,
    isSubscribed: PropTypes.bool,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("FooterStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: EmailSubscription.wrappedComponent,
  component: EmailSubscription,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Footer/EmailSubscription/index.js